/* Collapsible sections (snippets/jiec-fold-article.liquid, snippets/jiec-product-desc.liquid).
   - Preview | List switch on articles; the choice is remembered on this device.
   - "Close section" links at the end of open sections.
   - A link to a section (like #allergen-information) opens it.
   - Printing shows every section open. */
(function () {
  'use strict';

  var KEY = 'jiec-fold-view';
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function setView(root, view, save) {
    view = view === 'list' ? 'list' : 'preview';
    root.setAttribute('data-view', view);
    Array.prototype.forEach.call(root.querySelectorAll('[data-jiec-fold-view]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-jiec-fold-view') === view ? 'true' : 'false');
    });
    if (save) {
      try { localStorage.setItem(KEY, view); } catch (e) {}
    }
  }

  function init(root) {
    if (root.__jiecFold) return;
    root.__jiecFold = true;

    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    setView(root, stored || root.getAttribute('data-view'), false);

    Array.prototype.forEach.call(root.querySelectorAll('[data-jiec-fold-view]'), function (b) {
      b.addEventListener('click', function () {
        setView(root, b.getAttribute('data-jiec-fold-view'), true);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-jiec-fold-close]'), function (b) {
      b.hidden = false;
      b.addEventListener('click', function () {
        var details = b.closest('details');
        if (!details) return;
        details.open = false;
        var summary = details.querySelector('summary');
        if (details.getBoundingClientRect().top < 0) {
          details.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        if (summary) summary.focus({ preventScroll: true });
      });
    });
  }

  // Open the section a link points to, including any section it sits inside.
  function openFromHash() {
    var id = '';
    try { id = decodeURIComponent((location.hash || '').slice(1)); } catch (e) { return; }
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    var details = target.closest('details');
    if (!details || !details.closest('.jiec-fold, .jiec-desc__sec')) return;
    var opened = false;
    while (details) {
      if (!details.open) { details.open = true; opened = true; }
      details = details.parentElement ? details.parentElement.closest('details') : null;
    }
    if (opened) target.scrollIntoView({ block: 'start' });
  }

  var reopened = [];
  window.addEventListener('beforeprint', function () {
    reopened = [];
    Array.prototype.forEach.call(document.querySelectorAll('.jiec-fold details:not([open]), .jiec-desc__sec details:not([open])'), function (d) {
      d.open = true;
      reopened.push(d);
    });
  });
  window.addEventListener('afterprint', function () {
    reopened.forEach(function (d) { d.open = false; });
    reopened = [];
  });

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-jiec-fold]'), init);
    openFromHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('hashchange', openFromHash);
  document.addEventListener('shopify:section:load', boot);
})();
